import actionType from '../actions/computer/actionType';

const initialState: any = {
  searchParam: { pageNum: 1, pageSize: 50, status: '' },
  searchRes: {
    roomList: [],
    total: 0,
  },
  roomListLoading: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case actionType.UPDATE_STATE:
      return {
        ...state,
        ...action.payload,
      };
    case actionType.UPDATE_SEARCH_RES:
      return {
        ...state,
        searchRes: {
          ...state.searchRes,
          ...action.payload,
        },
      };
    // 更新搜索内容
    case actionType.UPDATE_SEARCH_PARAM:
      return {
        ...state,
        searchParam: {
          ...state.searchParam,
          [action.payload.field]: action.payload.value,
        },
      };
    default:
      return {
        ...state,
        ...action.payload,
      };
  }
};
